module.exports = __webpack_public_path__ + "img/mood-icon-5.7168d762.svg";